import React, { useContext, useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import ReactPlayer from 'react-player/youtube';
import useSWR from 'swr';

import useUser from '@/components/useUser';
import CreatedBy from '../CreatedBy';
import { IonIcon } from '../Icons';
import SocialIcon from '../SocialIcon';
import { UserFormatableTextDisplay } from '../form-fields/UserFormatableText';
import DeleteProjectModal from './DeleteProjectModal';
import ProjectType from './ProjectType';
import ProjectLocation from './ProjectLocation';

const ProjectDetailsAboutTab = ({ projectId }) => {
  const { user } = useUser();
  const router = useRouter();

  const { data: project } = useSWR(`/api/projects/${projectId}/`);

  const isCreatedByCurrentUser = project.created_by_user?.id === user?.id;

  // const pageLink = process.env.NEXT_PUBLIC_VERCEL_URL + router.asPath;
  const pageLink = (process.env.NEXT_PUBLIC_VERCEL_URL || '') + router.asPath;
  // if (typeof window !== 'undefined') pageLink = window.location.href;
  // wont do because SSR mistmatch at hydration error noise

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleDeleteProject = () => setShowDeleteModal(true);
  const onDeleteProject = () => router.push('/community-projects');

  return (
    <React.Fragment>
      <DeleteProjectModal
        project={project}
        showModal={showDeleteModal}
        onSuccess={onDeleteProject}
        onCancel={() => setShowDeleteModal(false)} />

      <div className="tags are-medium">
        {project.types.map(type => <ProjectType key={type} type={type} />)}
        <ProjectLocation project={project} />
      </div>

      <h2 className="subtitle">
        {project.title}
        {project.is_sample_project && (
          <span>
            {' '}
            <span className="tag is-maroon">Sample Project</span>
          </span>
        )}
      </h2>

      {isCreatedByCurrentUser && (
        <div className="buttons">
          <Link
            href={`/community-projects/${project.id}/edit`}
            className="button is-primary">

            <span>Edit</span>
            <span className="icon">
              <IonIcon name="create" size="large" />
            </span>

          </Link>
          <button className="button is-danger" onClick={handleDeleteProject}>
            <span>Delete</span>
            <span className="icon">
              <IonIcon name="trash" size="large" />
            </span>
          </button>
        </div>
      )}

      <CreatedBy className="block" user={project.created_by_user} createdAt={project.created_at} />

      <div className="block">
        <SocialIcon link={`https://www.facebook.com/sharer.php?u=${pageLink}`} name="Facebook" />

        <SocialIcon link={`https://twitter.com/share?url=${pageLink}&text=Hey%2C%20come%20check%20out%20this%20project%20on%20thrivespring.com!`} name="Twitter" />

        <SocialIcon link={`https://www.linkedin.com/cws/share/?url=${pageLink}`} name="LinkedIn" />
      </div>

      <UserFormatableTextDisplay className="block" value={project.description} />

      {project.video_link && (
        <div className="video-container" style={{position: 'relative', paddingTop: '56.25%', maxWidth: 640}}>
          <ReactPlayer
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
            }}
            width="100%"
            height="100%"
            url={project.video_link} />
        </div>
      )}
    </React.Fragment>
  );
};

export default ProjectDetailsAboutTab;
